/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
import "./App.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleHalfStroke,
  faEnvelope,
  faFilePdf,
  faTimes,
  faSpinner,
  faLink,
} from "@fortawesome/free-solid-svg-icons";
import { faLinkedinIn, faGithub } from "@fortawesome/free-brands-svg-icons";
import emailjs from "@emailjs/browser";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

function App() {
  const contact = (event) => {
    const loading = document.querySelector(".modal__overlay--loading");
    const success = document.querySelector(".modal__overlay--success");

    event.preventDefault();

    loading.classList += " modal__overlay--visible";
    emailjs
      .sendForm(
        "service_iw14wxo",
        "template_ahkrqok",
        event.target,
        "INM3kekNo10VyVuuF"
      )
      .then(() => {
        loading.classList.remove("modal__overlay--visible");
        success.classList += " modal__overlay--visible";
      })
      .catch((error) => {
        console.log(error);
        loading.classList.remove("modal__loading--visible");
        alert(
          "The email service is temporarily unavailable. Please reach me directly at michael@mtelakowicz.com"
        );
      });
  };

  const openModal = () => {
    document.getElementById("body").classList.add("modal--open");
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    document.getElementById("body").classList.remove("modal--open");
    document.body.style.overflow = '';
  };

  const toggleContrast = () => {
    document.getElementById("body").classList.toggle("dark-theme");
  };

  const moveBackground = (event) => {
    const shapes = document.querySelectorAll(".shape");
    const scaleFactor = 1 / 20;

    const x = event.clientX * scaleFactor;
    const y = event.clientY * scaleFactor;

    for (let i = 0; i < shapes.length; i++) {
      if (i % 2 === 0) {
        shapes[i].style.transform = `translate(${x}px, ${y}px)`;
      } else {
        shapes[i].style.transform = `translate(${-x}px, ${-y}px)`;
      }
    }
  };

  useEffect(() => {
    AOS.init({
      once: true,
    });
  }, []);

  return (
    <div id="body" onMouseMove={(event) => moveBackground(event)}>
      <a href="#landing-page">
        <div className="mail__btn--wrapper">
          <button
            className="mail__btn click"
            data-aos="zoom-in-left"
            data-aos-offset="0"
            data-aos-duration="700"
            onClick={() => openModal()}
          >
            <FontAwesomeIcon icon={faEnvelope} />
          </button>
        </div>
      </a>
      <section id="landing-page">
        <nav>
          <div
            className="nav__container"
            data-aos="fade-down"
            data-aos-duration="700"
            data-aos-delay="0"
          >
            <h2 className="logo">M|T</h2>
            <ul className="nav__link--list">
              <li className="nav__link">
                <a
                  href="#experience"
                  className="nav__link--anchor link__hover-effect link__hover-effect--black click"
                >
                  Experience
                </a>
              </li>
              <li className="nav__link">
                <a
                  href="#projects"
                  className="nav__link--anchor link__hover-effect link__hover-effect--black click"
                >
                  Projects
                </a>
              </li>
              <li className="nav__link">
                <a
                  href="#"
                  onClick={() => openModal()}
                  className="nav__link--anchor link__hover-effect link__hover-effect--black click"
                >
                  Contact
                </a>
              </li>
              <li
                className="nav__link click dark-mode--btn"
                onClick={() => toggleContrast()}
              >
                <a
                  href="#"
                  className="nav__link--anchor link__hover-effect link__hover-effect--black"
                >
                  <FontAwesomeIcon icon={faCircleHalfStroke} />
                </a>
              </li>
            </ul>
          </div>
        </nav>
        <header className="header">
          <div
            className="header__content"
            data-aos="zoom-in"
            data-aos-duration="700"
          >
            <h1 className="title">Hey</h1>
            <h1 className="title second--title purple">I'm Michael.</h1>
            <p className="header__para">
              I'm a <span className="purple">Full-Stack Developer</span> driven
              by a passion for crafting exceptional websites that cultivate a
              positive user experience.
              <br />
              Here is some more
              <span className="purple ml4 click" onClick={() => openModal()}>
                about me.
              </span>
            </p>
            <div className="about-me__links">
              <a
                href="https://www.linkedin.com/in/michael-telakowicz/"
                target="_blank"
                className="about-me__link click"
              >
                <FontAwesomeIcon icon={faLinkedinIn} />
              </a>
              <a
                href="https://github.com/teanmi"
                target="_blank"
                className="about-me__link click"
              >
                <FontAwesomeIcon icon={faGithub} />
              </a>

              <a
                target="_blank"
                href="../images/MichaelTelakowiczResume.pdf"
                className="about-me__link click"
              >
                <FontAwesomeIcon icon={faFilePdf} />
              </a>
            </div>
          </div>
        </header>

        <a href="#projects" className="scroll">
          <div
            className="scroll__icon click"
            data-aos="zoom-in-up"
            data-aos-offset="0"
            data-aos-delay="0"
            data-aos-duration="500"
          ></div>
        </a>
        <div className="modal">
          <div className="modal__half modal__about">
            <h3 className="modal__title--about modal__title">
              Here's a bit about me.
            </h3>
            <h4 className="modal__sub-title modal__sub-title--about">
              Full-Stack Developer
            </h4>
            <p className="modal__para">
              I'm a <span className="purple">full-stack developer</span> with a
              strong desire to contiue learning more in the field.
              <br />
              I'm currently in college at the{" "}
              <span className="purple">University of Akron</span> working
              towards a bachelors in{" "}
              <span className="purple">computer science.</span> Everyday I am
              continuing to learn and grow as a{" "}
              <span className="purple">developer</span>.
            </p>
            <div className="modal__languages">
              <figure className="modal__language">
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/HTML5_Badge.svg/240px-HTML5_Badge.svg.png"
                  alt="HTML"
                />
                <span className="language__name">HTML</span>
              </figure>
              <figure className="modal__language">
                <img
                  src="https://cdn.iconscout.com/icon/free/png-256/css-131-722685.png"
                  alt="CSS"
                />
                <span className="language__name">CSS</span>
              </figure>
              <figure className="modal__language">
                <img
                  src="https://cdn.iconscout.com/icon/free/png-256/javascript-1-225993.png"
                  alt="JavaScript"
                />
                <span className="language__name">JavaScript</span>
              </figure>
              <figure className="modal__language">
                <img
                  src="https://cdn.iconscout.com/icon/free/png-256/react-3-1175109.png"
                  alt="React"
                />
                <span className="language__name">React</span>
              </figure>
              <figure className="modal__language">
                <img src="./images/typescript.png" alt="TypeScript" />
                <span className="language__name">TypeScript</span>
              </figure>
              <figure className="modal__language">
                <img src="./images/sass.png" alt="SASS" />
                <span className="language__name">SASS</span>
              </figure>
              <figure className="modal__language">
                <img src="./images/tailwind.png" alt="Tailwind" />
                <span className="language__name">Tailwind</span>
              </figure>
              <figure className="modal__language">
                <img src="./images/nextjs.svg" alt="Next.js" />
                <span className="language__name">Next.js</span>
              </figure>
            </div>
          </div>
          <div className="modal__half modal__contact">
            <FontAwesomeIcon
              icon={faTimes}
              className="click modal__exit"
              onClick={() => closeModal()}
            />

            <h3 className="modal__title modal__title--contact">
              Let's have a chat!
            </h3>
            <h3 className="modal__sub-title modal__sub-title--contact">
              I'm looking forward to hearing from you.
            </h3>
            <form id="contact__form" onSubmit={(event) => contact(event)}>
              <div className="form__item">
                <label htmlFor="name" className="form__item--label">
                  Name
                </label>
                <input
                  className="input"
                  name="user_name"
                  type="text"
                  required
                />
              </div>
              <div className="form__item">
                <label htmlFor="name" className="form__item--label">
                  Email
                </label>
                <input
                  className="input"
                  name="user_email"
                  type="email"
                  required
                />
              </div>
              <div className="form__item">
                <label htmlFor="name" className="form__item--label">
                  Message
                </label>
                <textarea
                  className="input"
                  name="message"
                  type="text"
                  required
                ></textarea>
              </div>
              <button id="contact__submit" className="form__submit">
                Send it my way
              </button>
            </form>
            <div className="modal__overlay modal__overlay--loading">
              <FontAwesomeIcon icon={faSpinner} />
            </div>
            <div className="modal__overlay modal__overlay--success">
              Thanks for the message! Can't wait to speak to you soon!
            </div>
          </div>
        </div>
        <div
          className="shapes__wrapper"
          data-aos="fade"
          data-aos-delay="300"
          data-aos-duration="400"
        >
          <img src="./images/semi circle.svg" className="shape shape--0" />
          <img src="./images/circle.svg" className="shape shape--1" />
          <img src="./images/squiggly.svg" className="shape shape--2" />
          <img src="./images/circle.svg" className="shape shape--3" />
          <img src="./images/triangle.svg" className="shape shape--4" />
          <img src="./images/circle.svg" className="shape shape--5" />
          <img src="./images/squiggly.svg" className="shape shape--6" />
          <img src="./images/circle.svg" className="shape shape--7" />
          <img src="./images/semi circle.svg" className="shape shape--8" />
        </div>
      </section>
      <section id="experience">
        <div className="container">
          <div className="row">
            <h1
              className="section__title"
              data-aos="fade"
              data-aos-duration="700"
              data-aos-offset="50"
            >
              Professional <span className="purple">Experience</span>
            </h1>
            <ul
              className="experience__list"
              data-aos="zoom-in"
              data-aos-duration="600"
            >
              <div className="experience__wrapper">
                <div className="experience__list--triangle"></div>
                <li className="experience">
                  <div className="prcSaltillo experience__company open-sans">
                    <img
                      className="prcSaltillo__logo"
                      src="./images/PRC-Saltillo_Logo-modified.png"
                      alt="logo"
                    />
                    PRC-Saltillo
                  </div>
                  <ul>
                    <li className="experience__title">Junior Web Developer</li>
                    <li className="experience__technologies">
                      <span className="experience__technologies--title">
                        Technologies:
                      </span>{" "}
                      HTML, Tailwind, JavaScript, Vue.js, PHP, Laravel, SQL, Docker
                    </li>
                    <li className="experience__date">May 2025 - Present</li>
                  </ul>
                </li>
              </div>
              <div className="experience__wrapper">
                <li className="experience">
                  <div id="uakron" className="experience__company open-sans">
                    <div>
                      <img
                        id="uakron__logo"
                        src="./images/UAkron.png"
                        alt="University of Akron logo"
                      />
                      University of Akron{" "}
                    </div>
                    <p>College of Business</p>
                  </div>
                  <ul>
                    <li className="experience__title">Web Developer</li>
                    <li className="experience__technologies">
                      <span className="experience__technologies--title">
                        Technologies:
                      </span>{" "}
                      HTML, Bootstrap, CSS, Photoshop
                    </li>
                    <li className="experience__date">Mar 2024 - May 2026</li>
                  </ul>
                </li>
              </div>
              <div className="experience__wrapper">
                <li className="experience">
                  <div className="prcSaltillo experience__company open-sans">
                    <img
                      className="prcSaltillo__logo"
                      src="./images/PRC-Saltillo_Logo-modified.png"
                      alt="logo"
                    />
                    PRC-Saltillo
                  </div>
                  <ul>
                    <li className="experience__title">
                      Web Developer Intern
                    </li>
                    <li className="experience__technologies">
                      <span className="experience__technologies--title">
                        Technologies:
                      </span>{" "}
                      HTML, Tailwind, JavaScript, Vue.js, PHP, Laravel, SQL,
                      Docker
                    </li>
                    <li className="experience__date">May 2024 - Aug 2024</li>
                  </ul>
                </li>
              </div>
              <div className="experience__wrapper">
                <li className="experience">
                  <div
                    id="codehouseSolutions"
                    className="experience__company poppins"
                  >
                    <img
                      id="codehouse__logo"
                      src="./images/Code_House_Solutions_Logo.jpg"
                      alt="logo"
                    />
                    CODEHOUSE SOLUTIONS
                  </div>
                  <ul>
                    <li className="experience__title">
                      Software Engineer Intern
                    </li>
                    <li className="experience__technologies">
                      <span className="experience__technologies--title">
                        Technologies:
                      </span>{" "}
                      HTML, Tailwind, TypeScript, React.js, Next.js, AWS
                    </li>
                    <li className="experience__date">Jun 2023 - Sept 2023</li>
                  </ul>
                </li>
              </div>
              <div className="experience__wrapper">
                <li className="experience">
                  <div className="prcSaltillo experience__company open-sans">
                    <img
                      className="prcSaltillo__logo"
                      src="./images/PRC-Saltillo_Logo-modified.png"
                      alt="logo"
                    />
                    PRC-Saltillo
                  </div>
                  <ul>
                    <li className="experience__title">
                      Web Developer Intern
                    </li>
                    <li className="experience__technologies">
                      <span className="experience__technologies--title">
                        Technologies:
                      </span>{" "}
                      HTML, Tailwind, JavaScript, Vue.js, PHP, Laravel, SQL
                    </li>
                    <li className="experience__date">Jul 2023 - Sept 2023</li>
                  </ul>
                </li>
              </div>
              <div className="experience__wrapper">
                <li className="experience">
                  <h4
                    id="frontendSimplified"
                    className="experience__company open-sans"
                  >
                    <span className="lilita">
                      &lt;<span className="pacifico">/</span>&gt;
                    </span>{" "}
                    <span>
                      <span className="bold">Frontend</span> Simplified
                    </span>
                  </h4>
                  <ul>
                    <li className="experience__title">
                      Front-End Developer Intern
                    </li>
                    <li className="experience__technologies">
                      <span className="experience__technologies--title">
                        Technologies:
                      </span>{" "}
                      HTML, CSS, JavaScript, React.js
                    </li>
                    <li className="experience__date">Sept 2022 - Feb 2023</li>
                  </ul>
                </li>
              </div>
            </ul>
          </div>
        </div>
      </section>
      <section id="projects">
        <div className="container">
          <div className="row">
            <h1
              className="section__title"
              data-aos="fade"
              data-aos-duration="700"
              data-aos-offset="50"
            >
              Personal <span className="purple">Projects</span>
            </h1>
            <div className="project__container">
              <div className="project">
                <div
                  className="project__wrapper project__wrapper--housetab"
                  data-aos="zoom-in"
                  data-aos-duration="600"
                  data-aos-anchor-placement="top-center"
                >
                  <img
                    src="./images/HouseTab.png"
                    className="project__mockup"
                    alt="HouseTab"
                  />
                  <div className="project__wrapper--bg"></div>
                  <div className="project__description">
                    <h3 className="project__description--title">HouseTab</h3>
                    <h4 className="project__description--sub-title">
                      JS, React Native, Express.js, MySQL, Railway
                    </h4>
                    <p className="project__description--para">
                      Built a React Native mobile application that allows users to create and manage their own household budgets. The app features a user-friendly interface for adding expenses, categorizing them, and visualizing spending patterns through charts. It also includes authentication and data storage using Express.js and MySQL, deployed on Railway for continuos deployment.
                    </p>
                    <div className="project__description--links">
                      <a
                        target="_blank"
                        href="https://github.com/teanmi/HouseTab"
                        className="project__description--link"
                      >
                        <FontAwesomeIcon icon={faGithub} />
                      </a>
                      <a
                        target="_blank"
                        href="https://www.housetabapp.com/"
                        className="project__description--link"
                      >
                        <FontAwesomeIcon icon={faLink} />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="project">
                <div
                  className="project__wrapper project__wrapper--space-model"
                  data-aos="zoom-in"
                  data-aos-duration="600"
                  data-aos-anchor-placement="top-center"
                >
                  <img
                    src="./images/space-model.png"
                    className="project__mockup"
                    alt="Space Model"
                  />
                  <div className="project__wrapper--bg"></div>
                  <div className="project__description">
                    <h3 className="project__description--title">Space Model</h3>
                    <h4 className="project__description--sub-title">
                      Html, CSS, JS, React, Three.js
                    </h4>
                    <p className="project__description--para">
                      I created a 3D model of the Milky Way galaxy using
                      React.js and Three.js, making it visually appealing with
                      smooth transitions thanks to Tween.js. Additionally, I
                      enriched the experience by fetching detailed planet
                      descriptions from an API, adding an educational touch to
                      the project.
                    </p>
                    <div className="project__description--links">
                      <a
                        target="_blank"
                        href="https://github.com/teanmi/space-model"
                        className="project__description--link"
                      >
                        <FontAwesomeIcon icon={faGithub} />
                      </a>
                      <a
                        target="_blank"
                        href="https://space-model.web.app/"
                        className="project__description--link"
                      >
                        <FontAwesomeIcon icon={faLink} />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="project">
                <div
                  className="project__wrapper"
                  data-aos="zoom-in"
                  data-aos-duration="600"
                  data-aos-anchor-placement="top-center"
                >
                  <img
                    src="./images/gamemart.png"
                    className="project__mockup"
                    alt="Gamemart"
                  />
                  <div className="project__wrapper--bg"></div>
                  <div className="project__description">
                    <h3 className="project__description--title">Game Mart</h3>
                    <h4 className="project__description--sub-title">
                      Html, CSS, JS, React, Redux
                    </h4>
                    <p className="project__description--para">
                      I designed a comprehensive React-based multi-page website
                      for a video game eCommerce store. The website boasted
                      user-friendly features such as a search bar for easy game
                      discovery and an integrated shopping cart. Leveraging API
                      calls, I dynamically fetched and displayed video game
                      data, ensuring an engaging and seamless shopping
                      experience for users.
                    </p>
                    <div className="project__description--links">
                      <a
                        target="_blank"
                        href="https://github.com/teanmi/video-game-store"
                        className="project__description--link"
                      >
                        <FontAwesomeIcon icon={faGithub} />
                      </a>
                      <a
                        target="_blank"
                        href="https://game-mart-1617a.firebaseapp.com/"
                        className="project__description--link"
                      >
                        <FontAwesomeIcon icon={faLink} />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="project">
                <div
                  className="project__wrapper"
                  data-aos="zoom-in"
                  data-aos-duration="600"
                  data-aos-anchor-placement="top-center"
                >
                  <img
                    src="./images/linkedin.png"
                    className="project__mockup"
                    alt="LinkedIn Clone"
                  />
                  <div className="project__wrapper--bg"></div>
                  <div className="project__description">
                    <h3 className="project__description--title">
                      LinkedIn Clone
                    </h3>
                    <h4 className="project__description--sub-title">
                      Html, CSS, JS, React, Firebase
                    </h4>
                    <p className="project__description--para">
                      I crafted a LinkedIn Clone using React and Firebase,
                      offering users the choice of secure Gmail login or guest
                      access. The platform seamlessly integrates with Gmail
                      profiles, displaying users' profile pictures for a
                      personalized experience. Furthermore, I implemented the
                      ability to share video content alongside traditional
                      posts, enhancing engagement and user interaction within
                      this professional networking platform.
                    </p>
                    <div className="project__description--links">
                      <a
                        target="_blank"
                        href="https://github.com/teanmi/linkedin-clone"
                        className="project__description--link"
                      >
                        <FontAwesomeIcon icon={faGithub} />
                      </a>
                      <a
                        target="_blank"
                        href="https://linkedin-clone-d8538.web.app/home"
                        className="project__description--link"
                      >
                        <FontAwesomeIcon icon={faLink} />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="project">
                <div
                  className="project__wrapper"
                  data-aos="zoom-in"
                  data-aos-duration="600"
                  data-aos-anchor-placement="top-center"
                >
                  <img
                    src="./images/google.png"
                    className="project__mockup"
                    alt="Google Clone"
                  />
                  <div className="project__wrapper--bg"></div>
                  <div className="project__description">
                    <h3 className="project__description--title">
                      Google Clone
                    </h3>
                    <h4 className="project__description--sub-title">
                      Html, CSS, JavaScript, React
                    </h4>
                    <p className="project__description--para">
                      I engineered a Google Clone using React that harnesses the
                      power of Google's own API. This intuitive platform
                      empowers users to perform real-time searches on their
                      chosen topics, providing instant access to Google's search
                      results and information, all within a streamlined and
                      responsive interface.
                    </p>
                    <div className="project__description--links">
                      <a
                        target="_blank"
                        href="https://github.com/teanmi/google-clone"
                        className="project__description--link"
                      >
                        <FontAwesomeIcon icon={faGithub} />
                      </a>
                      <a
                        target="_blank"
                        href="https://fir-2b1d7.web.app/"
                        className="project__description--link"
                      >
                        <FontAwesomeIcon icon={faLink} />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="project">
                <div
                  className="project__wrapper"
                  data-aos="zoom-in"
                  data-aos-duration="600"
                  data-aos-anchor-placement="top-center"
                >
                  <img
                    src="./images/wordsearch.png"
                    className="project__mockup"
                    alt="WordSearch"
                  />
                  <div className="project__wrapper--bg"></div>
                  <div className="project__description">
                    <h3 className="project__description--title">Word Search</h3>
                    <h4 className="project__description--sub-title">
                      Html, CSS, JavaScript
                    </h4>
                    <p className="project__description--para">
                      I developed a Dictionary API using vanilla JavaScript that
                      offers a user-friendly experience. With a thoughtful
                      loading state, this tool enables users to search for words
                      and promptly receive comprehensive lists of definitions,
                      enhancing their language comprehension and communication
                      skills.
                    </p>
                    <div className="project__description--links">
                      <a
                        target="_blank"
                        href="https://github.com/teanmi/dictionaryapi"
                        className="project__description--link"
                      >
                        <FontAwesomeIcon icon={faGithub} />
                      </a>
                      <a
                        target="_blank"
                        href="https://teanmi.github.io/dictionaryapi/index.html"
                        className="project__description--link"
                      >
                        <FontAwesomeIcon icon={faLink} />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer>
        <div className="container">
          <div className="row footer__row">
            <h2 className="logo footer__logo">M|T</h2>
            <div className="footer__social--list">
              <a
                href="https://github.com/teanmi"
                target="_blank"
                className="footer__social--link link__hover-effect link__hover-effect--white"
              >
                GitHub
              </a>
              <a
                href="https://www.linkedin.com/in/michael-telakowicz/"
                target="_blank"
                className="footer__social--link link__hover-effect link__hover-effect--white"
              >
                LinkedIn
              </a>
              <a
                href="#"
                onClick={() => openModal()}
                className="footer__social--link link__hover-effect link__hover-effect--white"
              >
                Contact
              </a>

              <a
                target="_blank"
                href="../images/MichaelTelakowiczResume.pdf"
                className="footer__social--link link__hover-effect link__hover-effect--white"
              >
                Resume
              </a>
            </div>
            <p className="footer__copyright">
              Copyright &copy; 2023 Michael Telakowicz
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
